import React from "react";
import { URLs } from "../../utils/apis";
import { useStylesNotification } from "../../utils/mantine/useStylesNotification";
import { Box, Text } from "@mantine/core";
import CustomAnchor from "../mantineCustomComponents/CustomAnchor";

const QuotaLimit = () => {
  // css classes
  const { classes: notificationClasses } = useStylesNotification();
  return (
    <Box className={`${notificationClasses.notificationBlock} quota-used-100`}>
      <Box>
        <Text className={notificationClasses.notificationBlockText}>
          You&apos;ve used 100% of your stamp quota. Consider upgrading your{" "}
          <CustomAnchor
            text="Plan"
            href={URLs.PROFILE_PAYMENT_URL}
            componentClasses={`${notificationClasses.notificationBlockButtonsItem} ${notificationClasses.notificationBlockButtonsItemQuota100} buttonWhite`}
          ></CustomAnchor>
        </Text>
      </Box>
    </Box>
  );
};

export default QuotaLimit;
